import React, { Component } from 'react';
/* Components */
import Message from '../common/message';

class ModalEdit extends Component {
  constructor(props) {
    super(props);
    const obj = {};
    this.state = obj;
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.isRunUnitTest || (prevProps.userToEditStatus != 200 && this.props.userToEditStatus == 200)) {
      if(this.props.config.id) {
        this.props.userToEdit.roles.forEach( (item,i) => {
          if(this.props.config.roles.includes(item.valueKey)) {
            const elemCheck = this.props.permissionsRef[item.valueKey];
            if(elemCheck) {
              elemCheck.classList.add('select');
            }
          }
        });
        this.props.userToEdit.categories.forEach((item, i) => {
          if(this.props.config.tags.length > 0) {
            item.tags.forEach((tag, e) => {
              this.handleTag(this.props.config.tags, tag.valueKey, item.category.valueKey, this.props.multipleTagsAllow, `listup-${i}-${e}`);
            });
          }
        });

        // sets the permissions associated with media permissions
        this.props.handleSetPermissionsAssociatedWithMedia(null);
      }
    }
  }

  handleTag = (tagList, value, categoryName, multipleTagsAllow, id) => {
    var applyClass = 'block';
    var categoryHasAll = false;
    var emptyCategory = true;
    tagList.forEach( item => {
      if(item.tagCategory.toLowerCase() == categoryName.toLowerCase() && item.tag == value) {
        applyClass = 'select';
      }
      if(item.tagCategory.toLowerCase() == categoryName.toLowerCase() && item.tag == "*") {
        categoryHasAll = true;
      }
      if(item.tagCategory.toLowerCase() == categoryName.toLowerCase()) {
        emptyCategory = false;
      }
    });
    if((multipleTagsAllow && !categoryHasAll && applyClass!="select") || emptyCategory) {
      applyClass = '';
    }
    if(document.getElementById(id) && applyClass!='') {
      document.getElementById(id).classList.add(applyClass);
    }
  };

  render() {
    if(!this.props.modal) {
      return null;
    }
    return (
      <div
        data-close="ok"
        onClick={this.props.handleModal}
        className={`container-modal`}
      >
        <section className="module-title modal-title">
          <h2>{this.props.language.account.accountUser.editUser}</h2>
          {this.props.statusSave == 500 &&
            this.props.dataSave.error.params.map((item, i) => (
              <p key={i} className="error">
                {this.props.language.error[`cod${item.messageCode}`]}{' '}
              </p>
            ))}
          <a>
            <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
          </a>
        </section>
        {(this.props.statusSave != 200 && !this.props.userToEditLoading && 
          this.props.userToEditStatus == 200) && (
          <div className={`box-modal max500 min-height-needed`}>
            <section id="modal-edit" className="base-form">
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.accountUser.name}
                    <strong>(*)</strong>
                  </label>
                </div>
                <div>
                  <input type="hidden" defaultValue={this.props.config.id} id="id" />
                  <input
                    data-update="name"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.name}
                    type="text"
                    id="nameup"
                    className="modal-input"
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.accountUser.email} <strong>(*)</strong>{' '}
                  </label>
                </div>
                <div>
                  <input
                    data-update="mail"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.mail}
                    type="text"
                    id="mailup"
                    className="modal-input"
                  />
                </div>
              </div>
              {this.props.root == 'true' && (
                <div className="box-form islabel top">
                  <label className="container-checkbox">
                    {this.props.language.account.accountUser.isAdmin}
                    <input
                      data-update="rootes"
                      onChange={this.props.handleChange}
                      checked={this.props.config.rootes}
                      id="rooteup"
                      onClick={this.props.handleAdmin}
                      type="checkbox"
                    />
                    <span className="checkmark" />
                  </label>
                </div>
              )}
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.accountUser.rol}
                    <strong>(*)</strong>{' '}
                    <p> {this.props.language.account.accountUser.labelSelection}</p>
                  </label>
                </div>
                <div>
                  <ul className="multiple-select big" id="roleup">
                    {this.props.userToEdit.roles.map((item, i) => {
                      if (this.props.config.id) {
                        return (
                          <li
                            onClick={item.editable ? this.props.handleSelectCheck : null}
                            data-rolup={`rolup-${i}`}
                            data-parent={`rolup-${i}`}
                            data-roleparent={"roleup"}
                            id={`rolup-${i}`}
                            key={`rolup-${i}`}
                            data-value={item.valueKey}
                            className={(item.editable ? "enabled-item" : "disabled-item")}
                            ref={(el) => this.props.permissionsRef[item.valueKey] = el}
                          >
                            {this.props.language.account.accountUser[item.valueKey.toLowerCase()]}{' '}
                            <span className="help">
                              <i className="fas fa-question-circle" />
                              <div className="min">
                                {' '}
                                {this.props.language.account.roles[item.valueKey]}{' '}
                              </div>
                            </span>{' '}
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div>
              {this.props.filter.length > 0 && (
                <div className="module-title left">
                  <h2>
                    {this.props.language.account.others.categories} <strong>(*)</strong> <p>{this.props.language.account.others.categoriesHelp}</p>
                  </h2>
                  <p className="tagsSelectorDescription">{this.props.multipleTagsAllow ? this.props.language.account.others.selectMultipleItemsCategories : 
                    this.props.language.account.others.selectOneItemCategories}</p>
                </div>
              )}
              {this.props.userToEdit.categories.map((item, i) => (
                <div className="box-form islabel" key={`tags-${i}`}>
                  <div>
                    <label className="modal-label">
                      {this.props.language.filter[item.category.valueKey.toLowerCase()] + (item.category.accessDenied ? " - " + this.props.language.account.others.categoryAccessDenied : "")}
                    </label>
                  </div>
                  <div>
                    <ul
                      className={"multiple-select " + (this.props.multipleTagsAllow ? "big" : "radio")} 
                      id={`listup-${i}`}
                      data-listup={`listup-${i}`}
                    >
                      {item.tags.map((tag, e) => {
                        if (this.props.config.id) {
                          return (
                            <li
                              onClick={(tag.editable && !item.category.accessDenied) ? this.props.handleSelect : null}
                              data-parent={`listup-${i}`}
                              id={`listup-${i}-${e}`}
                              key={`listup-${i}-${e}`}
                              data-category={item.category.valueKey.toUpperCase()}
                              data-value={tag.valueKey}
                              className={(tag.editable && !item.category.accessDenied) ? "" : "disabled-item"}
                            >
                              {tag.valueKey == "*" ? this.props.language.all : tag.valueKey}
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                </div>
              ))}
            </section>
          </div>
        )}
        {this.props.userToEditLoading && (
          <div className={'box-form islabel top center modal-button-box min-height-needed'}>
            <div>
              <div className="spiner">
                <i className="fas fa-spinner fa-spin" /> {this.props.language.account.others.loading}
              </div>
            </div>
          </div>
        )}
        {(this.props.userToEditStatus != 200 && this.props.userToEditStatus != null) && (
          <div className={`box-modal max500 min-height-needed`}>
            <Message message={'API ERROR'} />
          </div>
        )}
        {(this.props.statusSave != 200 && !this.props.userToEditLoading &&
          this.props.userToEditStatus == 200) && (
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {this.props.loadingSave ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> {this.props.language.account.others.loading}
                </div>
              ) : (
                <input
                  className="active"
                  onClick={this.props.handleSubmit}
                  type="button"
                  value={this.props.language.account.accountUser.ActualizarUser}
                />
              )}
            </div>
          </div>
        )}
        {this.props.statusSave == 200 && (
          <div className={`box-modal max500 min-height-needed`}>
            <section className={'feed-back green'}>
              <div>
                <i className="fas fa-check-circle" />
              </div>
              <div>
                <p>{this.props.language.account.accountUser.userActivated}</p>
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default ModalEdit;



// WEBPACK FOOTER //
// ./source/client/components/account_user/modalEdit.jsx